// @flow
/* eslint-disable react/no-unused-prop-types */

import * as React from 'react';

import type { ActionStatus } from '../types';

type Props = {
  loading?: boolean,
  delay?: number,
  children: (options: { status: ActionStatus }) => React.Node,
  hasError?: boolean,
  status?: ActionStatus,
};

type State = {
  status: ActionStatus,
};

export default class StatusController extends React.Component<Props, State> {
  static defaultProps = {
    delay: 1500,
  };

  timer: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      status: props.status || '',
    };
  }

  oldDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (
      nextProps.status !== undefined &&
      nextProps.status !== prevState.status
    ) {
      return this.setState({
        status: nextProps.status,
      });
    }

    if (nextProps.loading) {
      return this.setState({
        status: 'loading',
      });
    } else if (
      !nextProps.loading &&
      prevState.status === 'loading' &&
      !nextProps.hasError
    ) {
      return this.setState({
        status: 'completed',
      });
    } else if (nextProps.hasError && prevState.status === 'loading') {
      return this.setState({
        status: 'error',
      });
    }

    return null;
  }

  componentDidMount() {
    this.oldDerivedStateFromProps(this.props, this.state);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.oldDerivedStateFromProps(this.props, this.state);
    }

    if (this.state.status !== 'completed' && this.state.status !== 'error') {
      return;
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.setState({
        status: '',
      });
    }, this.props.delay);
  }

  render() {
    return this.props.children({
      status: this.state.status,
    });
  }
}
